import { render } from "./AddElement.vue?vue&type=template&id=558caab6&scoped=true"
import script from "./AddElement.vue?vue&type=script&lang=js"
export * from "./AddElement.vue?vue&type=script&lang=js"

import "./AddElement.vue?vue&type=style&index=0&id=558caab6&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558caab6"]])

export default __exports__